import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../../../core/_BLComponent.jsx';

export default class FirstSlide extends BLComponent 
{
	
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 

	}

	componentDidMount() 
	{

	}

	render()
	{
		const {slidePrev, slideNext} = this.props.func;
		return (
			<React.Fragment>
				<div className="l-flex l-full-width">
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
					<div className="l-full-width">
						<div id="MPI-welcome-header-tour" className="text--center text--bold">
							Welcome to My Collection
						</div>
					</div>
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
				</div>
				<div className="l-flex">
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
					<div id="MPI-subtext-header-tour" className="text--small l-margin-top--xl l-full-width">
						My Collection is the best place to keep track of your physical collection of LEGO® items, including: sets, parts, minifigures, gear, books, and catalogs. 
					</div>
					<div className="personal-inventory__slide-section">
						&nbsp;
					</div>
				</div>
				<div className="l-flex l-margin-top--xl l-margin-bottom--xl">
					<div className="personal-inventory__slide-section personal-inventory__slide-section-left personal-inventory__hide-mobile">
						&nbsp;
					</div>
					<div className="text--small text--center personal-inventory__show-only-desktop" style={{margin:"auto"}}>
						<div className="personal-inventory__slide-item-box personal-inventory__slide-item-box--selected l-margin-bottom l-flex">
							<div><img src={"//" + blapp.config.getHost( "img" ) + "/ItemImage/ST/0/910017-1.t1.png"} style={{width:"40px", height:"40px"}}/></div>
							<div className="personal-inventory__slide-section-left l-margin-left" style={{width:"74px"}}>910017-1</div>
							<div className="personal-inventory__slide-section-left text--bold" style={{width:"160px"}}>Kakapo</div>
							<div className="personal-inventory__slide-section-left" style={{width:"74px"}}>New</div>
							<div className="personal-inventory__slide-section-right" style={{width:"90px"}}><input className="text-input text-input--sm" type="text" value={20} style={{width:"40px"}} disabled/></div>


						</div>

						<div className="personal-inventory__slide-item-box l-margin-bottom l-flex">
							<div><img src={"//" + blapp.config.getHost( "img" ) + "/ItemImage/ST/0/910010-1.t1.png"} style={{width:"40px", height:"40px"}}/></div>
							<div className="personal-inventory__slide-section-left l-margin-left" style={{width:"74px"}}>9100010-1</div>
							<div className="personal-inventory__slide-section-left text--bold" style={{width:"160px"}}>Great Fishing Boat</div>
							<div className="personal-inventory__slide-section-left" style={{width:"74px"}}>New</div>
							<div className="personal-inventory__slide-section-right" style={{width:"90px"}}><input className="text-input text-input--sm" type="text" value={2} style={{width:"40px"}} disabled/></div>	
						
						</div>

						<div className="personal-inventory__slide-item-box l-flex">
							<div><img src={"//" + blapp.config.getHost( "img" ) + "/ItemImage/ST/0/910001-1.t1.png"} style={{width:"40px", height:"40px"}}/></div>
							<div className="personal-inventory__slide-section-left l-margin-left" style={{width:"74px"}}>910001-1</div>
							<div className="personal-inventory__slide-section-left text--bold" style={{width:"160px"}}>Castle in the Forest</div>
							<div className="personal-inventory__slide-section-left" style={{width:"74px"}}>New</div>
							<div className="personal-inventory__slide-section-right" style={{width:"90px"}}><input className="text-input text-input--sm" type="text" value={5} style={{width:"40px"}} disabled/></div>	
							
						
						</div>
					</div>

					<div className="text--small text--center personal-inventory__show-only-tablet" style={{margin:"auto"}}>
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/personal-inventory/example-items-tablet@3x.png"} style={{width:"387px"}}/>
					</div>

					<div className="text--small text--center personal-inventory__show-only-mobile" style={{margin:"auto"}}>
						<img src={"//" + blapp.config.getHost( "static2" ) + "/img/personal-inventory/example-items-tablet@3x.png"} style={{width:"327px"}}/>
					</div>

					<div id="MPI-nextArrow-btn-tour" className="personal-inventory__slide-section  personal-inventory__slide-section-right l-cursor-pointer personal-inventory__hide-mobile" onClick={()=>slideNext()}>
						<i className="fas fa-chevron-right" title="Next slide"/>
					</div>
				</div>
			</React.Fragment>
		);
	}


};

 

